// extracted by mini-css-extract-plugin
export default {"activeBlock":"active-block-module__activeBlock--ktk64","delimiter":"active-block-module__delimiter--fr0SB"};